import * as React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import TranslateNew from '@translate/TranslateNew';
import {storeAppToken, updateAppToken} from '@services/user/user.actions';
import {Typography, WithStyles} from "@material-ui/core";
import {NotificationsStyles} from "@components/onboarding/steps/StepNotifications/notifications.styles";
import ProgressBar from "@components/common/progressBar/progressBar";
import Button from "@components/common/button/Button";
import { IAppToken } from '@app-types/websocket/user.types';
import { getAppTokenPlatform } from '@helpers/osDetection';
import { runCordovaPluginCall } from '@helpers/cordovaBridge';

const tn: TranslateNew = TranslateNew.getInstance();

interface INotificationsProps extends WithStyles<typeof NotificationsStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    updateToken: (token: IAppToken) => void;
    storeToken: (token: string) => void;
}

export class StepNotification extends React.Component<INotificationsProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const style = this.props.classes;

        return (
            <div className={style.root}>
                <div className={style.background}>
                    <div className={style.circle}/>
                </div>
                <div className={style.container}>
                    <div className={style.topBar}>
                        {this.props.progress && (<ProgressBar  value={this.props.progress}/>)}
                    </div>
                    <img alt="" src={require('@images/bells.svg')}/>
                    <div className={style.middleContent}>
                        <Typography variant="h2">{tn.lang.onbNotiTitle}</Typography>
                        <Typography>
                            {tn.lang.onbNotiText}
                        </Typography>
                    </div>
                    <div className={style.bottomContent}>
                        <Button
                            variant='contained'
                            color='primary'
                            size="large"
                            fullWidth={true}
                            onClick={(event) => this.requestPermission()}>
                            {tn.lang.onbNotiBtnYes}
                        </Button>

                        <Button
                            type="button"
                            variant='text'
                            onClick={(event) => this.props.nextStep()}>
                            {tn.lang.onbBtnMaybeLater}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    private requestPermission() {
        const FirebasePlugin = (globalThis as any).FirebasePlugin;

        if (!window.hasOwnProperty('cordova') || !FirebasePlugin) {
            this.props.nextStep();
            return;
        }

        const handleError = (error: any) => {
            console.warn("Could not register notifications", error);
        };

        const handleToken = (token: any) => {
            this.storeFirebaseToken(token);
        };

        const getToken = () => {
            try {
                const didStart = runCordovaPluginCall("FirebasePlugin.getToken", () => {
                    FirebasePlugin.getToken(handleToken, handleError);
                    return true;
                }, false);
                if (!didStart) {
                    console.warn("Could not register notifications because the Cordova bridge is unavailable.");
                }
            } catch (error) {
                handleError(error);
            }
        };

        const requestNativePermission = () => {
            if (typeof FirebasePlugin.grantPermission !== "function") {
                getToken();
                return;
            }

            try {
                const didStart = runCordovaPluginCall("FirebasePlugin.grantPermission", () => {
                    FirebasePlugin.grantPermission((hasPermission: boolean) => {
                        if (hasPermission === false) {
                            console.warn("Notification permission was not granted.");
                            return;
                        }

                        getToken();
                    }, handleError);
                    return true;
                }, false);
                if (!didStart) {
                    console.warn("Could not request notification permission because the Cordova bridge is unavailable.");
                }
            } catch (error) {
                handleError(error);
            }
        };

        // FirebaseX 18.0.7 does not invoke grantPermission's Android callback
        // when POST_NOTIFICATIONS is already granted. Check first so the token
        // is still registered in that case, and never make onboarding progress
        // depend on a native plugin callback.
        if (typeof FirebasePlugin.hasPermission === "function") {
            try {
                const didStart = runCordovaPluginCall("FirebasePlugin.hasPermission", () => {
                    FirebasePlugin.hasPermission((hasPermission: boolean) => {
                        if (hasPermission) {
                            getToken();
                            return;
                        }

                        requestNativePermission();
                    }, (error: any) => {
                        handleError(error);
                        requestNativePermission();
                    });
                    return true;
                }, false);
                if (!didStart) {
                    requestNativePermission();
                }
            } catch (error) {
                handleError(error);
                requestNativePermission();
            }
        } else {
            requestNativePermission();
        }

        this.props.nextStep();
    }

    private storeFirebaseToken(token: any) {
        if (!token || token === '') {
            console.warn("Firebase returned an empty notification token.");
            return;
        }

        this.props.storeToken(token);

        const platform = getAppTokenPlatform();
        if (platform) {
            this.props.updateToken({appToken: token, platform});
        } else {
            console.warn("Could not determine notification token platform.");
        }
    }
}

const mapDispatchToProps = {
    updateToken: updateAppToken,
    storeToken: storeAppToken,
};

export default connect(null, mapDispatchToProps)(withStyles(NotificationsStyles)(StepNotification));



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepNotifications/notifications.component.tsx